var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "analise" }, [
      _c(
        "div",
        { staticClass: "between" },
        [
          _c(
            "el-menu",
            {
              attrs: { "default-active": "analise", mode: "horizontal" },
              on: { select: _vm.changeSelect }
            },
            [
              _c("el-menu-item", { attrs: { index: "analise" } }, [
                _vm._v(_vm._s(_vm.tituloAnalise + " " + _vm.numeroProcesso))
              ]),
              _vm.tipo === "PEAS_FILHO"
                ? _c("el-menu-item", { attrs: { index: "mae" } }, [
                    _vm._v(
                      _vm._s(
                        "Processo Assentamento " +
                          _vm.processoMae.numeroProcesso
                      )
                    )
                  ])
                : _vm._e(),
              _vm.showSeparate
                ? _c("el-menu-item", { attrs: { index: "separate" } }, [
                    _vm._v("Análise do Processo")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm.idProcesso
            ? _c(
                "div",
                [
                  _c("app-opcoes-header-analise", {
                    attrs: {
                      idProcesso: _vm.idProcesso,
                      numeroProcesso: _vm.numeroProcesso,
                      statusProcesso: _vm.statusProcesso,
                      opcoesHeader: _vm.opcoesHeader,
                      tipoProcesso: _vm.tipo,
                      protocolo: _vm.numeroProtocolo,
                      idDespacho: _vm.idDespacho,
                      isEmissaoCertidao: _vm.isEmissaoCertidao,
                      btnPendencia: _vm.visualizarBotaoSinalizarPendencia,
                      btnRetificacao: _vm.btnSolicitarRetificacao,
                      btnNotificarInteressado: _vm.btnNotificarInteressado
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.selected === "analise"
        ? _c("div", [_vm._t("analise")], 2)
        : _vm.selected === "mae"
        ? _c("div", [_vm._t("mae")], 2)
        : _c("div", [_vm._t("separate")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f65dde6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f65dde6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/shared/AppAnaliseHeader.vue
// module id = null
// module chunks = 